// src/components/navigation/NavSection.jsx
// Collapsible navigation section component

import React from 'react';
import { NavLink } from 'react-router-dom';
import { SECTION_LABELS } from '../../config/navConfig';
import { getBadgeForItem } from '../../util/badgeUtils';
import NavItem from './NavItem';

function NavSection({
  section,
  items,
  isExpanded,
  onToggle,
  counts,
  warnings,
  userType,
  onNavigate,
  submenuState,
  onSubmenuToggle,
  collapsed
}) {
  if (!items || items.length === 0) {
    return null;
  }

  // Collapsed sidebar — render flat icon list (no section headers)
  if (collapsed) {
    return (
      <div className="nav-section">
        <ul className="nav-section-items">
          {items.map(item => {
            // For submenu parents in collapsed mode, just show the parent icon
            if (item.hasSubmenu) {
              return (
                <NavItem
                  key={item.id}
                  item={item}
                  badge={null}
                  warning={null}
                  userType={userType}
                  collapsed={true}
                />
              );
            }

            const badge = getBadgeForItem(item, counts);
            const warning = item.warningKey && warnings[item.warningKey];

            return (
              <NavItem
                key={item.id}
                item={item}
                badge={badge}
                warning={warning}
                userType={userType}
                collapsed={true}
              />
            );
          })}
        </ul>
      </div>
    );
  }

  // Expanded sidebar — current behavior with section headers
  return (
    <div className={`nav-section ${isExpanded ? 'expanded' : 'collapsed'}`}>
      {/* Section Header */}
      <div
        className="nav-section-header"
        onClick={() => onToggle(section)}
      >
        <span>{SECTION_LABELS[section]}</span>
        <span className={`chevron ${isExpanded ? 'open' : ''}`}>&#9660;</span>
      </div>

      {/* Section Items */}
      {isExpanded && (
        <ul className="nav-section-items">
          {items.map(item => {
            // Handle items with submenus (like Automations)
            if (item.hasSubmenu && item.submenu) {
              const isSubmenuOpen = submenuState && submenuState[item.id];
              return (
                <React.Fragment key={item.id}>
                  <li>
                    <div
                      className={`text-light submenu-parent ${
                        window.location.pathname === item.route ? 'active' : ''
                      }`}
                      onClick={() => onSubmenuToggle && onSubmenuToggle(item.id)}
                      style={{ cursor: 'pointer', padding: '10px 15px' }}
                    >
                      <span>
                        <i className={`${item.icon} nav-item-icon`}></i>
                        {item.label}
                      </span>
                      <span className={`chevron ${isSubmenuOpen ? 'open' : ''}`}>
                        &#9660;
                      </span>
                    </div>
                  </li>
                  {isSubmenuOpen && item.submenu.map(subItem => (
                    <li key={subItem.id} className="submenu-item">
                      <NavLink
                        activeClassName="active"
                        className="text-light"
                        to={subItem.route}
                        onClick={onNavigate}
                      >
                        {subItem.label}
                      </NavLink>
                    </li>
                  ))}
                </React.Fragment>
              );
            }

            // Regular menu item
            const badge = getBadgeForItem(item, counts);
            const warning = item.warningKey && warnings[item.warningKey];

            return (
              <NavItem
                key={item.id}
                item={item}
                badge={badge}
                warning={warning}
                userType={userType}
                onNavigate={onNavigate}
                collapsed={false}
              />
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default NavSection;
